<template>
  <v-container
    fluid
    class="w-100 pa-2 d-flex flex-column"
    style="min-height: 10vh"
  >
    <div class="d-flex justify-center align-center" style="position: relative">
      <span></span>
      <h2 class="text-subtitle-1" style="opacity: 0.7">فروشگاه های آنلاین</h2>
    </div>

    <v-row justify="center">
      <v-col cols="12">
        <v-card flat class="mx-auto w-100" style="overflow-x: hidden">
          <v-slide-group
            v-model="model"
            class=""
            style=""
            show-arrows
            center-active
            dir="rtl"
          >
            <v-slide-item
              v-for="(n, index) in value"
              :key="n.id || index"
              v-slot="{ active, toggle }"
              class="mx-2 w-100"
              style=""
            >
              <b-floor-shop :details="n" :shopDetails="shopsHandler(n.qr_id)" />
            </v-slide-item>
          </v-slide-group>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bFloorShop from "./bFloorShop.vue";

export default {
  name: "bFloorShops",

  components: { bFloorShop },

  props: {
    value: Array,
    shops: Array,
  },

  data() {
    return {
      model: null,
    };
  },

  methods: {
    shopsHandler(id) {
      const find = this.shops.find((item) => item.qr_id == id);
      return find;
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 70vh;
}
.v-item-group >>> .v-slide-group__prev {
  min-width: 15px;
}
.v-item-group >>> .v-slide-group__next {
  min-width: 15px;
}
</style>
